import { action } from 'typesafe-actions'

import { RequestTicket } from 'src/types'

import { ReceiptsActionTypes } from './types'

export const removeReceipt = (receipt: RequestTicket) =>
  action(ReceiptsActionTypes.REMOVE_RECEIPT, { receipt })

export const removeReceiptSuccess = () =>
  action(ReceiptsActionTypes.REMOVE_RECEIPT_SUCCESS)

export const removeReceiptFailure = (message: string) =>
  action(ReceiptsActionTypes.REMOVE_RECEIPT_FAILURE, { message })

export const saveReceipt = (receipt: RequestTicket) =>
  action(ReceiptsActionTypes.SAVE_RECEIPT, { receipt })

export const saveReceiptSuccess = () =>
  action(ReceiptsActionTypes.SAVE_RECEIPT_SUCCESS)

export const saveReceiptFailure = (message: string, policyViolated?: boolean) =>
  action(ReceiptsActionTypes.SAVE_RECEIPT_FAILURE, { message, policyViolated })

export const setSavedReceipt = (receipt: RequestTicket) =>
  action(ReceiptsActionTypes.SET_SAVED_RECEIPT, { receipt })
